export default {
  setConnectInfo: function (state, info) { // connect information save
    state.connectInfo = info
  },
  setFormLayer: function (state, payload) {
    state.showFormLayer = payload.showFormLayer
  }
}
